import { render, staticRenderFns } from "./Consultants.vue?vue&type=template&id=6e8b46c9&"
import script from "./Consultants.vue?vue&type=script&lang=js&"
export * from "./Consultants.vue?vue&type=script&lang=js&"
import style0 from "./Consultants.vue?vue&type=style&index=0&id=6e8b46c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports